import 'date-fns'
import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import DateFnsUtils from '@date-io/date-fns'
import { 
  MuiPickersUtilsProvider,
  KeyboardDatePicker 
} from '@material-ui/pickers'
import { IconButton, Paper, FormControl, Select, MenuItem } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { SearchInput } from 'components'
import { numberFormat } from 'helpers'

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1)
    }
  },
  searchInput: {
    [theme.breakpoints.down('sm')]: {
      flexBasis: 'auto',
      width: '100%'
    }
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr auto',
      gap: theme.spacing(0.5)
    }
  },
  spacer: {
    flexGrow: 1
  },
  date: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    display: 'flex',
    backgroundColor: '#FFF',
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      padding: theme.spacing(0.5, 0.5)
    }
  },
  statusSelect: {
    marginLeft: theme.spacing(2),
    minWidth: 150,
    backgroundColor: '#FFF',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      minWidth: 'auto',
      width: '100%'
    }
  },
  clearButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      padding: theme.spacing(0.5)
    }
  },
  total: {
    marginLeft: theme.spacing(10),
    fontSize: theme.spacing(4),
    backgroundColor: '#FFF',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      textAlign: 'center',
      fontSize: theme.spacing(2.5),
      padding: theme.spacing(1),
      borderRadius: '4px'
    }
  }
}))

const Toolbar = ({ 
  className, 
  onSearch, 
  startDate, 
  endDate, 
  status,
  onChangeStatus,
  onChangeStartDate,
  onChangeEndDate,
  onClearDate,
  sum,
  ...rest 
}) => {
  const classes = useStyles()

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.row}>
          <SearchInput
            className={classes.searchInput}
            placeholder="Cari transaksi"
            onChange={onSearch}
          />

          <div className={classes.filterRow}>
            <FormControl className={classes.statusSelect} variant="outlined" size="small">
              <Select
                labelId="status-filter-label"
                id="status-filter"
                value={status !== undefined && status !== null ? status : ''}
                onChange={onChangeStatus}
                style={{ paddingTop: '5px', paddingBottom: '5px', fontSize: '13px' }}
                label="Status"
                displayEmpty
                renderValue={(selected) => {
                  if (selected === '0' || selected === 0) {
                    return 'Dalam Proses'
                  }
                  if (selected === '1' || selected === 1) {
                    return 'Selesai'
                  }
                  if (selected === '2' || selected === 2) {
                    return 'Ditolak'
                  }
                  return 'Semua'
                }}
              >
                <MenuItem value="">Semua</MenuItem>
                <MenuItem value={0}>Dalam Proses</MenuItem>
                <MenuItem value={1}>Selesai</MenuItem>
                <MenuItem value={2}>Ditolak</MenuItem>
              </Select>
            </FormControl>

            <Paper className={classes.date}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                id="start-date"
                placeholder="Tgl Mulai"
                style={{ paddingTop: '5px', paddingBottom: '5px' }}
                value={startDate}
                InputProps={{ disableUnderline: true, style: { fontSize: '13px' } }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                  style: { padding: '4px' }
                }}
                error={false}
                helperText={null}
                onChange={onChangeStartDate}
              />
            </Paper>

            <Paper className={classes.date}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                id="end-date"
                placeholder="Tgl Akhir"
                style={{ paddingTop: '5px', paddingBottom: '5px' }}
                value={endDate}
                InputProps={{ disableUnderline: true, style: { fontSize: '13px' } }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                  style: { padding: '4px' }
                }}
                error={false}
                helperText={null}
                onChange={onChangeEndDate}
              />
            </Paper>
            <IconButton 
              onClick={onClearDate}
              className={classes.clearButton}
              color="inherit"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          <div className={classes.total}>
            {numberFormat(sum.toFixed(2), 'Rp. ')}
          </div>
        </div>
      </MuiPickersUtilsProvider>
    </div>
  )
}

Toolbar.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  status: PropTypes.any,
  onChangeStatus: PropTypes.func,
  onChangeStartDate: PropTypes.func,
  onChangeEndDate: PropTypes.func,
  onClearDate: PropTypes.func,
  sum: PropTypes.number
}

export default Toolbar
